import createReactComponent from '../createReactComponent';
export default createReactComponent('alarm-minus', 'AlarmMinus', [["path",{"d":"M3 5.231 6.15 3M21 5.231 17.85 3M20 13a8 8 0 1 1-16 0 8 8 0 0 1 16 0M9.5 13h5","key":"svg-0"}]]);